import { useEffect, useState } from "react";
import { Modal, Input, Button, Select, Form, Space } from "antd";
import { GetAllPerfCyclesApi } from "../../api/GetAllPerfCyclesApi";
import moment from "moment";

const { TextArea } = Input;
const { Option } = Select;

const MetabaseCodeModal = ({ isOpen, onClose, onSubmit, selectedPosition }) => {
  const [form] = Form.useForm();
  const [cycles, setCycles] = useState([]);

  useEffect(() => {
    if (isOpen) {
      getPerfCycles();
      form.setFieldsValue({
        payload: selectedPosition?.metabaseCode || "",
        cycle: undefined,
      });
    }
  }, [isOpen, form]);

  async function getPerfCycles() {
    const apiResponse = await GetAllPerfCyclesApi();
    if (apiResponse.success) {
      setCycles(apiResponse.data);
    }
  }

  const handleFinish = (values) => {
    onSubmit(values);
    form.resetFields();
    onClose();
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={"Add Metabase Payload"}
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
    >
      <p>
        Add the Metabase payload for the position{" "}
        <strong>
          {selectedPosition?.designation?.name}, {selectedPosition?.unit?.name}
        </strong>
      </p>
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          label="Select Performance Cycle"
          name="cycle"
          rules={[
            { required: true, message: "Please select a performance cycle" },
          ]}
        >
          <Select
            allowClear
            showSearch
            placeholder="Select cycle"
            optionFilterProp="children"
          >
            {cycles.map((cycle) => {
              return (
                <Option key={cycle.id} value={cycle.id}>
                  {cycle.name +
                    " (" +
                    moment(cycle.startingOn).format("DD.MM.YYYY") +
                    " - " +
                    moment(cycle.endingOn).format("DD.MM.YYYY") +
                    ")"}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item
          label="Payload"
          name="payload"
          rules={[{ required: true, message: "Please enter the payload" }]}
        >
          <TextArea
            placeholder="Paste the payload here..."
            autoSize={{ minRows: 6, maxRows: 20 }}
            style={{
              fontFamily: "monospace",
            }}
          />
        </Form.Item>

        <Form.Item>
          <Space style={{ float: "right" }}>
            <Button onClick={handleCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default MetabaseCodeModal;
